window.TratezCart = window.TratezCart || {};

(function (ns) {
  function reapplyLandingPage() {
    var attrs = {};
    try {
      if (typeof window.TratezCart.getTrackingAttrs === 'function') {
        attrs = window.TratezCart.getTrackingAttrs() || {};
      } else if (typeof window.TratezCart.getLandingPage === 'function') {
        var lp = window.TratezCart.getLandingPage();
        if (lp) attrs.landing_page = lp;
      }
    } catch (e) {
      /* silent fail */
    }

    // never send empty values - Shopify removes the attribute
    var clean = {};
    Object.keys(attrs).forEach(function (k) {
      if (attrs[k]) clean[k] = attrs[k];
    });

    if (!Object.keys(clean).length) return Promise.resolve();

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ attributes: clean }),
      keepalive: true
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        console.log('[TRATEZ TRACKING] attributes re-applied after clear+add:', data.attributes);
      })
      .catch(function (err) {
        console.error('[TRATEZ TRACKING] Failed to re-apply attributes', err);
      });
  }

  function triggerThemeCartEvents() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:open'));
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
    document.dispatchEvent(new CustomEvent('product:added'));
  }

  /**
   * Clears the cart, adds one item, re-applies the landing_page attribute,
   * then redirects.
   *
   * button/options are OPTIONAL — callers that don't manage a button label
   * (like the simple buyCta/buyOnce widget) can omit them and this behaves
   * exactly like a plain addAndGo(variant, qty, plan, checkoutUrl) call.
   * Callers that do manage a button (like the tratez-sc section widget)
   * pass button + options to get the disable/label/timeout behavior back.
   *
   * @param {string|number} variant
   * @param {number} qty
   * @param {string|number|null} plan   null/'' for a one-time purchase
   * @param {string} checkoutUrl
   * @param {HTMLElement} [button]
   * @param {Object} [options]
   * @param {string} [options.addingText]
   * @param {string} [options.addedText]
   * @param {Function} [options.onComplete]
   * @param {Function} [options.onError]
   * @param {Object} [properties]  optional line item properties, merged into the
   *                               /cart/add.js payload only when it has at least one key
   */
  function addAndGo(variant, qty, plan, checkoutUrl, button, options, properties) {
    if (!variant) return;
    options = options || {};
    ns.clearInProgress = true;

    var originalText = button ? button.innerHTML : '';

    if (button) {
      button.disabled = true;
      button.innerHTML = options.addingText || originalText;
    }

    window.upcartShouldSkipAddToCartInterceptor = function () { return true; };
    window.upcartShouldSkipAddToCart = function () { return true; };

    var payload = { id: Number(variant), quantity: Number(qty) };
    if (plan) payload.selling_plan = Number(plan);
    if (properties && typeof properties === 'object' && Object.keys(properties).length) {
      payload.properties = properties;
    }

    fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (e) { throw e; });
        }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(payload)
        });
      })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (e) { throw e; });
        }
        return response.json();
      })
      .then(function () {
        return reapplyLandingPage();
      })
      .then(function () {
        if (button) button.innerHTML = options.addedText || originalText;

        setTimeout(function () {
          triggerThemeCartEvents();
        }, 300);

        setTimeout(function () {
          window.location.href = checkoutUrl;
        }, 500);

        setTimeout(function () {
          ns.clearInProgress = false;
          if (button) {
            button.disabled = false;
            button.innerHTML = originalText;
          }
          if (typeof options.onComplete === 'function') options.onComplete();
        }, 1200);
      })
      .catch(function (error) {
        console.error(error);
        ns.clearInProgress = false;

        if (button) {
          button.disabled = false;
          button.innerHTML = error && error.description ? error.description : originalText;
        }

        setTimeout(function () {
          if (button) button.innerHTML = originalText;
          if (typeof options.onError === 'function') options.onError();
        }, 1800);
      });
  }

  ns.reapplyLandingPage = reapplyLandingPage;
  ns.triggerThemeCartEvents = triggerThemeCartEvents;
  ns.addAndGo = addAndGo;
})(window.TratezCart); 